<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small"
                        @change="handleStoreChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="顾客信息：">
                    <el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small"
                        @change="inputChange">
                        <el-option v-for="item in customerList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单编号：">
                    <el-input v-model="formInline.code" placeholder="请输入订单编号" clearable size="small"
                        @change="inputChange"></el-input>
                </el-form-item>
                <el-form-item label="会员编号：">
                    <el-input v-model="formInline.vipNo" placeholder="请输入会员编号" clearable size="small"
                        @change="inputChange"></el-input>
                </el-form-item>
                <el-form-item label="订单状态：">
                    <el-select v-model="formInline.state" placeholder="请选择订单状态" size="small"
                        @change="inputChange">
                        <el-option v-for="item in stateList" :label="item.name" :value="item.code"
                            :key="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单来源：">
                    <el-select v-model="formInline.orderSource" placeholder="请选择订单来源" size="small"
                        @change="inputChange">
                        <el-option v-for="item in orderSourceList" :label="item.name" :value="item.code"
                            :key="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否确认：">
                    <el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" size="small"
                        @change="inputChange">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="已确认" :value="true"></el-option>
                        <el-option label="未确认" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单日期：">
                    <el-date-picker v-model="dateStr" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="handleDateChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/salesOrder/index', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                    <el-button v-if="this.$checkBtnPermission('/salesOrder/index', 'export')" size="small"
                        type="warning" class="el-icon-download" @click="exportSalesOrder">
                        导出
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe>
                <el-table-column slot="code" label="订单号" width="220" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="handleDetail(scope.row)">
                            {{ scope.row.code }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column slot="stateStr" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 1" type="warning">{{ scope.row.stateStr }}</el-tag>
                        <el-tag v-else-if="scope.row.state === 2" type="danger">{{ scope.row.stateStr }}</el-tag>
                        <el-tag v-else-if="scope.row.state === 4" type="info">{{ scope.row.stateStr }}</el-tag>
                        <el-tag v-else type="success">{{ scope.row.stateStr }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column slot="isConfirm" label="是否确认" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
                        <el-tag v-else type="danger">未确认</el-tag>
                    </template>
                </el-table-column>
                <el-table-column slot="arrearsMoney" label="欠款金额" width="100" align="center">
                    <template slot-scope="scope">
                        {{ (scope.row.totalMoney - scope.row.totalPayMoney).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column slot="isPhoneBonus" label="是否电话提成" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isPhoneBonus" type="success">有</el-tag>
                        <el-tag v-else type="danger">没有</el-tag>
                    </template>
                </el-table-column>
                <el-table-column slot="isGrantBonus" label="是否提成" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isGrantBonus" type="success">已创建</el-tag>
                        <el-tag v-else type="danger">未创建</el-tag>
                    </template>
                </el-table-column>

                <el-table-column slot="operation" label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="btnPermission.delete && !scope.row.isConfirm" size="mini"
                            class="el-icon-delete" type="danger" @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                        <el-button v-if="btnPermission.confirm && !scope.row.isConfirm" size="mini"
                            class="el-icon-finished" type="warning" @click="handleConfirm(scope.row)">
                            确认
                        </el-button>
                        <el-button v-if="btnPermission.repairArrears && scope.row.isConfirm && scope.row.state === 2"
                            size="mini" class="el-icon-finished" type="warning" @click="handleRepairArrears(scope.row)">
                            补欠款
                        </el-button>
                        <el-button
                            v-if="btnPermission.createCommission && scope.row.isConfirm && !scope.row.isGrantBonus"
                            size="mini" class="el-icon-cherry" type="success"
                            @click="handleCreateCommission(scope.row)">
                            创建提成
                        </el-button>
                        <el-button v-if="btnPermission.cancel && scope.row.isConfirm && scope.row.state === 3"
                            size="mini" class="el-icon-delete" type="danger" @click="handleCancel(scope.row)">
                            退单
                        </el-button>
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
        <!-- 补欠款 -->
        <el-dialog :visible.sync="dialogVisible" title="补欠款" style="width: 60%; margin: auto;" append-to-body
            :close-on-click-modal="false">
            <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付方式:</strong></span>
            <el-select v-model.number="payType.payTypeId" placeholder="请选择支付方式" clearable filterable size="small"
                style="width: 100%;">
                <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
                    :key="item.payTypeId"></el-option>
            </el-select>
            <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付金额:</strong></span>
            <el-input v-model.number="payType.payMoney" placeholder="请输入支付金额" style="width: 100%;"
                size="small"></el-input>
            <span style="display: block; margin-bottom: 10px"><strong>支付备注:</strong></span>
            <el-input v-model="payType.payComment" placeholder="请输入支付备注" style="width: 100%;" size="small"></el-input>
            <span slot="footer">
                <el-button @click="dialogVisible = false" icon="el-icon-close" size="small">取消</el-button>
                <el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting"
                    @click="handleSubmitPayArrears">确认</el-button>
            </span>
        </el-dialog>
        <!-- 创建提成 -->
        <createCommission ref="createCommission"></createCommission>
        <!-- 销售订单详情 -->
        <detailDialog ref="detailDialog"></detailDialog>
    </div>
</template>

<script>
import {
    GetSalesOrderPageList,
    DeleteSalesOrder,
    ConfirmSalesOrder,
    PaySalesOrderArrearsMoney,
    ExportSalesOrder,
    CancelSalesOrder,
} from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detailDialog from "@/views/product/sales/detailDialog.vue";
import createCommission from "@/views/product/sales/createCommission.vue";
import { downloadFile } from "@/utils/export.js";
import {
    GetCustomerListByStore
} from "@/api/baseDataApi.js";

export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "销售订单",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            selectionList: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                isConfirm: null,
                code: "",
                vipNo: "",
                state: 0,
                orderSource: 0,
                customerKeyId: "",
                startTime: null,
                endTime: null,
            },
            storeList: [],
            columnsData: [],
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "createTime",
                    label: "下单时间",
                    width: "170",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "storeName",
                    label: "门店名称",
                    isKeep: true,
                    minWidth: "100",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "customer.name",
                    label: "顾客姓名",
                    minWidth: "90",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "orderSourceStr",
                    label: "订单来源",
                    minWidth: "150",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "totalProductMoney",
                    label: "订单金额",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "totalMoney",
                    label: "收费金额",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "content",
                    label: "订单商品内容",
                    width: "320",
                    align: "center",
                },
                {
                    slot: "code",
                    label: "订单号",
                    minWidth: "180",
                    isKeep: true,
                    align: "center",
                },
                {
                    prop: "customer.phone",
                    label: "顾客手机号",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "creator",
                    label: "经办人",
                    width: "100",
                    align: "center",
                },
                {
                    slot: "stateStr",
                    label: "状态",
                    minWidth: "80",
                    align: "center",
                },
                {
                    prop: "vipInfo.vipNo",
                    label: "会员号",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "vipInfo.balance",
                    label: "会员余额",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "totalPayMoney",
                    label: "总支付金额",
                    minWidth: "120",
                    align: "center",
                },
                {
                    slot: "arrearsMoney",
                    label: "欠款金额",
                    minWidth: "120",
                    align: "center",
                },
                {
                    slot: "isConfirm",
                    label: "是否确认",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "确认人",
                    align: "center",
                }, ,
                {
                    prop: "confirmDate",
                    label: "确认时间",
                    align: "center",
                    width: "170",
                },
                {
                    slot: "isPhoneBonus",
                    label: "电话提成",
                    align: "center",
                    width: "100",
                },
                {
                    prop: "phoneBonusUserName",
                    label: "电话提成人",
                    align: "center",
                    width: "120",
                },
                {
                    slot: "isGrantBonus",
                    label: "是否提成",
                    align: "center",
                    width: "100",
                },
                {
                    prop: "grantBonusUserName",
                    label: "创建提成人",
                    align: "center",
                    width: "120",
                },
                {
                    prop: "grantTime",
                    label: "创建提成时间",
                    align: "center",
                    width: "170",
                },
                {
                    slot: "operation",
                    label: "操作",
                    minWidth: "120",
                    align: "center",
                    fixed: "right",
                },
            ],
            btnPermission: {
                confirm: false,
                delete: false,
                repairArrears: false,
                createCommission: false,
                cancel: false,
                export: false,
            },
            stateList: [],
            orderSourceList: [],
            payTypeList: [],
            payType: {
                keyId: '',
                payTypeId: 1,
                payMoney: 0,
                payComment: "",
            },
            dialogVisible: false,
            isSubmitting: false,
            dateStr: [],
            customerList: [],
        };
    },
    // 注册组件
    components: {
        detailDialog,
        createCommission,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.getListData();
        this.GetOrgInfoListByConfig();
        this.getOrderStatusList();
        this.getOrderSourceList();
        this.getPayTypeList();
        // 检查按钮权限
        this.btnPermission.confirm = this.$checkBtnPermission('/salesOrder/index', 'confirm');
        this.btnPermission.delete = this.$checkBtnPermission('/salesOrder/index', 'delete');
        this.btnPermission.repairArrears = this.$checkBtnPermission('/salesOrder/index', 'repairArrears');
        this.btnPermission.createCommission = this.$checkBtnPermission('/salesOrder/index', 'createCommission');
        this.btnPermission.cancel = this.$checkBtnPermission('/salesOrder/index', 'cancel');
        this.btnPermission.export = this.$checkBtnPermission('/salesOrder/index', 'export');
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetSalesOrderPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 点击删除按钮
        handleDelete(row) {
            this.$confirm("确认删除该订单吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.loading = true;
                DeleteSalesOrder({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.getListData();
                        this.$message({
                            type: "success",
                            message: "订单删除成功！",
                        });
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error("订单删除失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
        },
        // 点击确认按钮
        handleConfirm(row) {
            this.$confirm("是否确认该订单？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.loading = true;
                ConfirmSalesOrder({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.getListData();
                        this.$message({
                            type: "success",
                            message: "订单确认成功！",
                        });
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error("订单确认失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消确认",
                });
            });
        },
        //获取订单来源
        getOrderSourceList() {
            GetEnumConfigListByCode({
                code: "StoreOrderSource",
            }).then((res) => {
                if (res.code == 1) {
                    this.orderSourceList = [];
                    res.data.forEach((item) => {
                        this.orderSourceList.push({
                            code: parseInt(item.code),
                            name: item.name,
                        });
                    });
                    this.orderSourceList.unshift({
                        code: 0,
                        name: "全部",
                    });
                } else {
                    this.$message({
                        type: "info",
                        message: res.msg,
                    });
                }
            }).catch((err) => {
                this.$message.error("数据加载失败，请稍后再试！");
            });
        },
        //获取销售订单状态
        getOrderStatusList() {
            GetEnumConfigListByCode({
                code: "SalesOrderState",
            }).then((res) => {
                if (res.code == 1) {
                    this.stateList = [];
                    res.data.forEach((item) => {
                        this.stateList.push({
                            code: parseInt(item.code),
                            name: item.name,
                        });
                    });
                    this.stateList.unshift({
                        code: 0,
                        name: "全部",
                    });
                } else {
                    this.$message({
                        type: "info",
                        message: res.msg,
                    });
                }
            }).catch((err) => {
                this.$message.error("数据加载失败，请稍后再试！");
            });
        },
        // 点击补欠款按钮
        handleRepairArrears(row) {
            this.$confirm("是否补该订单的欠款？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.payType.keyId = row.keyId;
                this.dialogVisible = true;
            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消补欠款",
                });
            });
        },
        // 充值记录补款弹窗
        handleSubmitPayArrears() {
            // 表单验证
            if (!this.payType.payTypeId) {
                this.$message.error('请选择支付方式');
                return;
            }

            if (typeof this.payType.payMoney !== 'number' || isNaN(this.payType.payMoney)) {
                this.$message.error('请输入有效的数字金额');
                return;
            }

            if (!this.payType.payMoney || this.payType.payMoney <= 0) {
                this.$message.error('请输入有效的支付金额（必须大于0）');
                return;
            }

            this.$confirm('确认补款吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.isSubmitting = true;
                PaySalesOrderArrearsMoney(this.payType)
                    .then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                type: "success",
                                message: "充值记录补款成功！",
                            });
                            this.getListData();
                            this.dialogVisible = false;
                            this.payType = {
                                keyId: '',
                                payTypeId: 1,
                                payMoney: 0,
                                payComment: "",
                            };
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("充值记录补款失败，请稍后再试！");
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消充值记录补款",
                });
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        //获取状态信息
        getPayTypeList() {
            const paramer = {
                code: "PayType",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.payTypeList = [];
                        res.data.forEach((item) => {
                            this.payTypeList.push({
                                payTypeId: parseInt(item.code),
                                payTypeName: item.name,
                            });
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取状态信息失败!");
                });
        },
        // 点击详情按钮
        handleDetail(row) {
            this.$refs.detailDialog.getDetailDialog(row);
        },
        // 点击创建销售订单提成按钮
        handleCreateCommission(row) {
            this.$refs.createCommission.getCreateCommissionDialog(row);
        },
        // 导出销售订单
        exportSalesOrder() {
            // 确认导出
            this.$confirm('确认导出选中门店的销售订单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ExportSalesOrder(this.formInline).then((res) => {
                    if (res.code == 1) {
                        downloadFile(res.data, "销售订单.xlsx");
                        this.$message.success("导出销售订单成功！");
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch((err) => {
                    this.$message.error("导出销售订单失败，请稍后再试！");
                });
            });
        },
        // 日期选择器改变事件
        handleDateChange(val) {
            if (val) {
                this.formInline.startTime = val[0];
                this.formInline.endTime = val[1];
            } else {
                this.formInline.startTime = null;
                this.formInline.endTime = null;
            }
            this.search();
        },
        // 点击退单按钮
        handleCancel(row) {
            this.$confirm('确认退单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                CancelSalesOrder({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "退单成功！",
                        });
                        this.getListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch((err) => {
                    this.$message.error("退单失败，请稍后再试！");
                });
            });
        },
        // 获取客户信息列表
        GetCustomerList(storeKeyId) {
            const paramer = {
                keyId: storeKeyId,
            };
            GetCustomerListByStore(paramer)
                .then((res) => {
                    this.customerList = [];
                    if (res.code == 1) {
                        this.customerList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取客户信息失败!");
                });
        },
        // 门店选择器事件
        handleStoreChange(val) {
            if (val.length > 0) {
                this.formInline.storeKeyId = val;
                this.GetCustomerList(val);
            } else {
                this.formInline.storeKeyId = "";
                this.customerList = [];
            }
        },
    }
};
</script>

<style scoped></style>